import { render, staticRenderFns } from "./WillPartnerResidesDetails.vue?vue&type=template&id=620109d6"
import script from "./WillPartnerResidesDetails.vue?vue&type=script&lang=js"
export * from "./WillPartnerResidesDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports